import React from "react";

const ContinuePhase6or7BubbleContent = ({ startPhase6or7 }) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-4">
        <div>
          Hasta el momento hemos definido los objetivos de aprendizaje de la
          sesión y hemos seleccionado las actividades que conformarán la sesión
          ENAd que estamos planeando, pero es momento de tomar una decisión
          importante. ⚠️
        </div>
        <div>
          ¿De qué manera quieres seguir realizando el resto de la planeación?
          Puedes elegir entre las siguientes opciones:
        </div>
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-4 shadow-lg p-4">
            <div className="text-shaiaBlue font-bold">
              Revisemos juntos el detalle de cada actividad
            </div>
            <div>
              Te guiaré paso a paso en lo que falta del proceso de planeación,
              asegurando que cada aspecto se ajuste a tus necesidades y
              expectativas. ¡Podremos hacer ajustes y reflexiones en tiempo
              real!
            </div>
            <div className="text-right">
              <button
                className="text-Yellow-500 font-bold"
                type="button"
                onClick={() => startPhase6or7(3)}
              >
                Seleccionar
              </button>
            </div>
          </div>
          <div className="flex flex-col gap-4 shadow-lg p-4">
            <div className="text-shaiaBlue font-bold">
              Genera el detalle de cada actividad automáticamente
            </div>
            <div>
              Utilizaré la información que hemos definido hasta ahora para
              completar automáticamente lo que falta de la planeación, lo que te
              permitirá ahorrar tiempo. Sin embargo, ten en cuenta que esta
              planificación puede no ser de la misma calidad que si trabajáramos
              juntos.
            </div>
            <div className="text-right">
              <button
                className="text-Yellow-500 font-bold"
                type="button"
                onClick={() => startPhase6or7(4)}
              >
                Seleccionar
              </button>
            </div>
          </div>
          <div>
            Por favor, selecciona la opción que prefieras y continuaremos. ✨
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContinuePhase6or7BubbleContent;
